import React from 'react';
import styles from './StatBlock.module.css';

/**
 * StatBlock   big number + small label underneath.
 * variant: 'default' | 'gradient' | 'light'
 */
const StatBlock = ({ value, label, variant = 'default', className = '' }) => {
  return (
    <div className={`${styles.block} ${styles[variant]} ${className}`}>
      <div className={styles.value}>{value}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default StatBlock;
